/* This is for 72.91 */

module.exports = {
  endpoints: {
    category: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/products/category'
    },
    categoryV4: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v4/rilfnl/products/category'
    },
    categoryV5: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v5/rilfnl/products/category'
    },
    capsulecp: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/capsule'
    },
    capsulenewin: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/capsule/capsuleNewIn'
    },
    topSearches: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/products'
    },
    products: {
      href: 'https://pdpaggregator.services.ajio.com/aggregator/pdp'
    },
    checkProductServiceability:{
      href: 'http://pdpaggregator.services.ajio.com/aggregator/pdp/serviceability'
    },
    curatedPage: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/category'
    },
    recommend: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/recommend'
    },
    recommendation: {
      href: 'https://sf.ajio.com/rilfnlwebservices/recommendation/v1/pairing/products'
    },
    ensamble: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/ensamble'
    },
    recentlyViewed: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/recentlyViewed'
    },
    productdeliverycheck: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/productdeliverycheck'
    },
    capsules: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/capsule/productCapsule'
    },
    search: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/products/search'
    },
    searchV4: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v4/rilfnl/products/search'
    },
    searchV5: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v5/rilfnl/products/search'
    },
    newdesignhomepage: {
      // this should not be changed
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/newdesignhomepage'
    },
    landingPageRuntime: {
      href: 'http://sf.ajio.ril.com/storefront/cms/page'
    },
    cmsComponent: {
      href: 'http://sf.ajio.ril.com/storefront/cms/component'
    },
    runtimeLocale: {
      href: 'http://sf.ajio.ril.com/storefront/cms/locale'
    },
    runtimeNavigationDesktop: {
      href: 'http://sf.ajio.ril.com/storefront/cms/navigation'
    },
    runtimeNavigationDesktopPreview: {
      href: 'http://gcpcms.services.ajio.jio.com/cms-editor/v1/navigation/preview'
    },
    landingPageRuntimePreview: {
      href: 'http://gcpcms.services.ajio.jio.com/cms-editor/v1/page/preview'
    },
    landingPageRuntimeArchive: {
      href: 'http://gcpcms.services.ajio.jio.com/cms-editor/v1/page/archive'
    },
    newcategoryselection: {
      // this should not be changed
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/newcategoryselection'
    },
    searchsuggestions: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/products/suggestions'
    },
    navigationdesktop: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/navigation/all'
    },
    navigationmobile: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/navigation/navnodes'
    },
    myaccount: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/navigation'
    },
    footer: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/footer/navlinks'
    },
    minicart: {
      href: 'https://sf.ajio.ril.com/cart/rollover/json/MiniCart'
    },
    wishlist: {
      href: 'https://sf.ajio.ril.com/addToWishlistAjax'
    },
    leaderBoard: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/topshopper'
    },
    accountCheck: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/accountCheck'
    },
    loginToken: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/oauth/token'
    },
    selfcarefaq: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/selfcare/footer'
    },
    selfcareFaqSearch: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/searchService/FAQ/search'
    },
    selfcareInitChat: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/selfcare/initiateChat'
    },
    generateLoginOTP: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/login/sendOTP'
    },
    signUpAndSocial: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users'
    },
    signInSocial: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users'
    },
    setNewPassword: {
      href:
        'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/forgottenpasswordtokens/set/password'
    },
    selfcareOrderDetails: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users'
    },
    getProfile: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users/current'
    },
    npsFormQuestionsData: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/survey'
    },
    npsFormAnswerSubmit: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/survey/submitsurvey'
    },
    getStoreList: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/SISStore'
    },
    getStoreListCms: {
      href: 'http://sf.ajio.ril.com/storefront/cms/stores'
    },
    getStoreListCmsRevampedPreview: {
      href:
        'http://gcpcms.services.ajio.jio.com/cms-editor/store/preview?platform=MOBILE&tenantId=AJIO'
    },
    sizeGuide: {
      href: 'http://sizechart.services.ajio.com/sizechart/getBrickBrandVendorStyleSizeChart'
    },
    productLevelSizeGuide: {
      href: 'http://sizechart.services.ajio.com/sizechart/productLevelSizeGuide'
    },
    recommendUserSize: {
      href: 'http://sizechart.services.ajio.com/sizechart/recommendUserSize'
    },
    fetchUserSizeGuide: {
      href: 'http://sizechart.services.ajio.com/sizechart/fetchUserSizeGuide'
    },
    kioskIPWhitelist: {
      href: 'https://assets.ajio.com/snoop/kioskIPWhitelist.json'
    },
    submitAssistantId: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/submitEmpId'
    },
    verifyOTP: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/login/verifyOTP'
    },
    generateCreditUsageOTP: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/kiosk/sendOTP'
    },
    signUpKiosk: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/registerKiosk'
    },
    kioskEntryPage: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/kiosklandingpage'
    },
    sessionClear: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users'
    },
    checkDeliveryDetails: {
      href: 'https://pdpaggregator.services.ajio.com/aggregator/edd/checkDeliveryDetails'
    },
    checkServiceableCart: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users'
    },
    mobileBottomNavList: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/cms/component'
    },
    uploadReturnProductImages: {
      href:
        'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users/USER_EMAIL_ID/returns/uploadReturnimage'
    },
    fetchIfscCodeDetails: {
      href: 'https://payment.services.ajio.com/payment-engine/api/v1/bank/details'
    },
    luxeBrandsList: {
      href:
        'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/catalogs/rilfnlProductCatalog/Online/categories/luxebrands'
    },
    bankOffers: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/allActiveBankOffer'
    },
    fetchBankTransferStatus: {
      href: 'https://payment.services.ajio.com/payment-engine/api/v1/refund/bank-transfer-status'
    },
    roadblock: {
      href:
        'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/roadblockbannercmp?uiel=Mobile&format=json'
    },
    appticker: {
      href:
        'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/appstickybannercmp?uiel=Mobile&format=json'
    },
    affiseGetConversions: {
      href: 'https://api-ajios.affise.com/3.0/stats/conversions'
    },
    affiseEditConversions: {
      href: 'https://api-ajios.affise.com/3.0/admin/conversion/edit'
    },
    affisePostback: {
      href: 'https://offers-ajios.affise.com/postback'
    },
    customerTypeUAAS: {
      href: 'http://uaas.ajio.com/uaas/v2/rilfnl/users/CUSTOMER_ID/customertype'
    },
    customerTypeUAASV4: {
      href: 'http://uaas.ajio.com/uaas/v4/rilfnl/users/customertype?service='
    },
    myAccountCMS: {
      href: 'http://sf.ajio.ril.com/storefront/cms/page/static?content=navigation&name=myaccount'
    },
    uaasVerifyPan: {
      href: 'http://uaas.ajio.com/uaas/users/verifyTaxPayerId'
    },
    accountDelete: {
      href: 'http://sf.ajio.ril.com/uaas/users/CUSTOMER_ID/deleteAccount'
    },
    rushAvailabilityCall: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v1/deliveryType/availability'
    },
    productDeliveryTypeRush: {
      href: 'http://pdpaggregator.services.ajio.com/aggregator/pdp/deliveryType'
    },
    jioAdsSapiApi: {
      href: 'https://mercuryads.jio.com/delivery/sapi.php'
    },
    recommendationWidgetOsmos: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/recommendation/v1/page/data'
    },
    bannerAdsOsmos: {
      href: 'https://ajio-ba.o-s.io/v2/bsda/pt'
    },
    osmosClickTracker: {
      href: 'https://t.o-s.io/aclick/'
    },
    osmosImpressionTracker: {
      href: 'https://t.o-s.io/events?event_name=funnel_impression'
    },
    recommendationTrendsVibes: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/recommendation/v1/trends'
    },
    crossSellCartRecommendations: {
      href: 'https://gcprep-search.services.ajio.jio.com/searchservices/v1/cross-sell/recommendations'
    }
  },
  properties: {
    version: '01.03.00',
    environment: 'PREVIEW',
    siteUrl: 'https://www.ajio.com',
    parentUrl: 'https://www.ajio.com',
    baseImgUrl: 'https://www.ajio.com',
    assetUrl: 'https://assets.ajio.com',
    imageBaseUrl: 'https://assets.ajio.com',
    wishlistUrl: 'http://sf.ajio.ril.com',
    apiUrl: 'https://sf.ajio.ril.com',
    npeBaseUrl: 'http://runtime.promoengine.services.ajio.com',
    cemUrl: 'https://www.ajio.com/cem',
    previewCheck: true,
    gtmCode: 'T9R7HP2',
    optimizeID: 'GTM-NLD5ZNR',
    GAID: 'UA-68002030-3',
    APIErrorGAID: 'UA-68002030-3',
    appAjioText: 'AJIO Online Shopping App',
    appAjioInstallText: 'Use App for a better experience',
    androidAppBaseLink: 'android-app://com.ril.ajio/',
    iosAppBaseLink: 'ios-app://1113425372/',
    fbAppId: '530272470511330',
    googleClientId: '451315316170-qir4dv350qkc1214i1786p0tq184df0m.apps.googleusercontent.com',
    roadBlock: true,
    timeout: 25000,
    timeoutNode: 30000,
    timeoutClient: 40000,
    dropAtStore: 'ON',
    dropAtStoreBanner: 'Available only at Trends stores in Bangalore',
    pickFromStore: 'OFF',
    pickFromStoreBanner: 'Available only at Trends stores in Bangalore',
    dataGrinchAppKey: 'app5b30bd81184dfd0962a57ab3',
    downloadInvoiceFlag: true,
    cleverTapID: 'TEST-485-5Z9-WZ5Z',
    firebaseConfig: JSON.stringify({
  
    }),
    firebaseConfig_M: JSON.stringify({

    }),
    webAppVersion: '1.0.0',
    copilotURL: 'https://script.copilot.live/v1/copilot.min.js?tkn=cat-6cvtdddi',
    amplitude_experiment_server_key: 'server-AblRWcufkysyE4w4XxpxB7N8XuL517jZ',
    ajioLoyaltyServiceUrl: 'https://payment.services.ajio.com',
    botifyWebsiteId: 'UO4YE7',
    amplitude_api_key: '9ac8bf1364978b2734f25fe8793278c8'
  }
};